import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import { filter, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TemplateEmailModal",
  components: {
    GenericModal,
    InlinePrompt
  },
  props: {
    emailTemplates: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searchString: ""
    };
  },
  computed: {
    hasTemplates() {
      return !isEmpty(this.emailTemplates);
    },
    hasFilteredTemplates() {
      return !isEmpty(this.filteredEmailTemplates);
    },
    filteredEmailTemplates() {
      if (this.searchString.length < 3) return this.emailTemplates;
      return filter(this.emailTemplates, template => {
        var _context;
        return _includesInstanceProperty(_context = `${template.name} ${template.description}`.toLowerCase()).call(_context, this.searchString.toLowerCase());
      });
    }
  },
  methods: {
    handleHidden() {
      this.searchString = "";
    },
    loadTemplate(templateId) {
      this.$hideModal();
      this.$emit("select", templateId);
    },
    deleteTemplate(templateId) {
      this.$emit("delete", templateId);
    }
  }
});